{
  "version": "v4.0.0",
  "name": "EnableFeeCollector",
  "bytecodeTemplate": "01010300000009b413c40de0b6b3a7640000a2{1}13c40de0b6b3a76400000e0c{0}0103",
  "fieldsSig": {
    "names": [
      "tokenPairFactory",
      "tokenPair"
    ],
    "types": [
      "TokenPairFactory",
      "TokenPair"
    ],
    "isMutable": [
      false,
      false
    ]
  },
  "functions": [
    {
      "name": "main",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": []
    }
  ]
}